import { CALL_API, Schemas } from '../../common/middleware/api';

export const CHILD_LESSONS_UNPAGED_REQUEST = 'CHILD_LESSONS_UNPAGED_REQUEST';
export const CHILD_LESSONS_UNPAGED_SUCCESS = 'CHILD_LESSONS_UNPAGED_SUCCESS';
export const CHILD_LESSONS_UNPAGED_FAILURE = 'CHILD_LESSONS_UNPAGED_FAILURE';

export const CHILD_LESSON_UPDATE_REQUEST = 'CHILD_LESSON_UPDATE_REQUEST';
export const CHILD_LESSON_UPDATE_SUCCESS = 'CHILD_LESSON_UPDATE_SUCCESS';
export const CHILD_LESSON_UPDATE_FAILURE = 'CHILD_LESSON_UPDATE_FAILURE';

export const GENERATE_CHILD_LESSONS_REQUEST = 'GENERATE_CHILD_LESSONS_REQUEST';
export const GENERATE_CHILD_LESSONS_SUCCESS = 'GENERATE_CHILD_LESSONS_SUCCESS';
export const GENERATE_CHILD_LESSONS_FAILURE = 'GENERATE_CHILD_LESSONS_FAILURE';

export const LESSON_ATTENDANCE_WEEKLY_PROGRAMS_REQUEST = 'LESSON_ATTENDANCE_WEEKLY_PROGRAMS_REQUEST';
export const LESSON_ATTENDANCE_WEEKLY_PROGRAMS_SUCCESS = 'LESSON_ATTENDANCE_WEEKLY_PROGRAMS_SUCCESS';
export const LESSON_ATTENDANCE_WEEKLY_PROGRAMS_FAILURE = 'LESSON_ATTENDANCE_WEEKLY_PROGRAMS_FAILURE';

export const WEEKLY_PROGRAM_BY_CENTER_AND_TERM_REQUEST = 'WEEKLY_PROGRAM_BY_CENTER_AND_TERM_REQUEST';
export const WEEKLY_PROGRAM_BY_CENTER_AND_TERM_SUCCESS = 'WEEKLY_PROGRAM_BY_CENTER_AND_TERM_SUCCESS';
export const WEEKLY_PROGRAM_BY_CENTER_AND_TERM_FAILURE = 'WEEKLY_PROGRAM_BY_CENTER_AND_TERM_FAILURE';

export const ADD_MAKEUP_REQUEST = 'ADD_MAKEUP_REQUEST';
export const ADD_MAKEUP_SUCCESS = 'ADD_MAKEUP_SUCCESS';
export const ADD_MAKEUP_FAILURE = 'ADD_MAKEUP_FAILURE';

export const MARK_AS_PAID_MAKEUP_REQUEST = 'MARK_AS_PAID_MAKEUP_REQUEST';
export const MARK_AS_PAID_MAKEUP_SUCCESS = 'MARK_AS_PAID_MAKEUP_SUCCESS';
export const MARK_AS_PAID_MAKEUP_FAILURE = 'MARK_AS_PAID_MAKEUP_FAILURE';

export const CANCEL_TRIAL_RESERVATION_REQUEST = 'CANCEL_TRIAL_RESERVATION_REQUEST';
export const CANCEL_TRIAL_RESERVATION_SUCCESS = 'CANCEL_TRIAL_RESERVATION_SUCCESS';
export const CANCEL_TRIAL_RESERVATION_FAILURE = 'CANCEL_TRIAL_RESERVATION_FAILURE';

export const loadUnpagedChildLessons = (options) => ({
	[CALL_API]: {
		types: [CHILD_LESSONS_UNPAGED_REQUEST, CHILD_LESSONS_UNPAGED_SUCCESS, CHILD_LESSONS_UNPAGED_FAILURE],
		endpoint: 'api/childLessons/unpaged',
		request: options,
		schema: Schemas.CHILD_LESSONS_ARRAY,
		replace: { replace: true }
	}
});

export const updateChildLesson = (id, lesson) => ({
	[CALL_API]: {
		types: [CHILD_LESSON_UPDATE_REQUEST, CHILD_LESSON_UPDATE_SUCCESS, CHILD_LESSON_UPDATE_FAILURE],
		endpoint: `api/childLessons/${id}`,
		method: 'PUT',
		request: lesson,
		schema: Schemas.CHILD_LESSON
	}
});

export const generateChildLessons = (options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [GENERATE_CHILD_LESSONS_REQUEST, GENERATE_CHILD_LESSONS_SUCCESS, GENERATE_CHILD_LESSONS_FAILURE],
		endpoint: 'api/childLessons/generate',
		request: options,
		method: 'POST',
		form: 'generateChildLessonsForm',
		schema: Schemas.CHILD_LESSONS_ARRAY,
		onSuccessEvent
	}
});

export const loadWeeklyProgram = (options) => ({
	[CALL_API]: {
		types: [LESSON_ATTENDANCE_WEEKLY_PROGRAMS_REQUEST, LESSON_ATTENDANCE_WEEKLY_PROGRAMS_SUCCESS, LESSON_ATTENDANCE_WEEKLY_PROGRAMS_FAILURE],
		endpoint: 'api/weeklyPrograms/unpaged',
		request: options,
		schema: Schemas.WEEKLY_PROGRAM_ARRAY
	}
});

export const loadWeeklyProgramByCenterAndTerm = (centerId, termId) => (dispatch, getState) => {
	const weeklyProgramByCenterAndTerm = getState().filters.weeklyProgramByCenterAndTerm;
	if (weeklyProgramByCenterAndTerm[`${centerId}-${termId}`]) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [WEEKLY_PROGRAM_BY_CENTER_AND_TERM_REQUEST, WEEKLY_PROGRAM_BY_CENTER_AND_TERM_SUCCESS, WEEKLY_PROGRAM_BY_CENTER_AND_TERM_FAILURE],
			endpoint: 'api/weeklyPrograms/unpaged',
			request: { centerId, termId, isDeleted: false },
			schema: Schemas.WEEKLY_PROGRAM_ARRAY
		},
		centerId,
		termId
	});
}

export const addMakeup = (options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [ADD_MAKEUP_REQUEST, ADD_MAKEUP_SUCCESS, ADD_MAKEUP_FAILURE],
		endpoint: 'api/booking',
		request: options,
		method: 'POST',
		form: 'newMakeupForm',
		onSuccessEvent
	}
});

export const markAsPaidMakeup = (options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [MARK_AS_PAID_MAKEUP_REQUEST, MARK_AS_PAID_MAKEUP_SUCCESS, MARK_AS_PAID_MAKEUP_FAILURE],
		endpoint: 'api/booking/payment',
		request: options,
		method: 'POST',
		form: 'newMakeupForm',
		onSuccessEvent
	}
});

export const cancelTrialReservation = (paymentId, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CANCEL_TRIAL_RESERVATION_REQUEST, CANCEL_TRIAL_RESERVATION_SUCCESS, CANCEL_TRIAL_RESERVATION_FAILURE],
		endpoint: 'api/trialReservations',
		request: { paymentId },
		method: 'DELETE',
		onSuccessEvent
	}
});